<div class="card-menu-wrapper">
  <ng-container *ngTemplateOutlet="cardItemTemplate; context: { item: cardItem(), currentLevel: 0 }"></ng-container>
</div>

<ng-template #cardItemTemplate let-item="item" let-currentLevel="currentLevel">
  @if (item.access) {
    <div class="card-item" (click)="emitCardClick(item)">
      @if (item.link) {
        <button class="icon-favorite" [ngClass]="{ full: item.liked }" (click)="onToggleFavorite($event, item)">
          <i class="fa-solid fa-star"></i>
        </button>
      }

      <img [src]="iconGenerate(item)" class="icon-menu" />

      <h3 class="card-menu-title">
        {{ item.title }}
        @if (item.parentTitle || parentTitle()) {
          <small>[ {{ item.parentTitle || parentTitle() }} ]</small>
        }
      </h3>

      <p class="card-menu-description">{{ item.description }}</p>

      @if (item.link) {
        <a
          class="link-open"
          target="_blank"
          [attr.href]="item.link"
          [attr.aria-label]="'Abrir ' + item.title + ' em nova aba'"
        >
          <i class="fa-solid fa-up-right-from-square"></i>
        </a>
      } @else {
        <button class="btn-more">
          <span>more</span>
          <i class="fa-solid fa-arrow-right-long"></i>
        </button>
      }
    </div>
  }
</ng-template>
